import React from "react";
import { Box, Typography } from "@mui/material";

const getPercent = (completed, total) => {
  if (!total || Number(total) === 0) return 0;
  return Math.round((Number(completed) / Number(total)) * 100);
};

const getStyles = (percent) => {
  if (percent > 90) {
    return {
      bg: "#e6f9f0",
      border: "#34d399",
      color: "#065f46",
    };
  }
  if (percent >= 70) {
    return {
      bg: "#fff8e1",
      border: "#facc15",
      color: "#92400e",
    };
  }
  return {
    bg: "#fdecea",
    border: "#f87171",
    color: "#7f1d1d",
  };
};

const CountWithPercent = ({ completed, total }) => {
  const percent = getPercent(completed, total);
  const styles = getStyles(percent);

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography variant="body2">
        {completed}/{total || 0}
      </Typography>

      <Box
        sx={{
          px: 1,
          py: "2px",
          borderRadius: "999px",
          fontSize: 12,
          fontWeight: 700,
          border: `1px solid ${styles.border}`,
          backgroundColor: styles.bg,
          color: styles.color,
          minWidth: 50,
          textAlign: "center",
        }}
      >
        {percent}%
      </Box>
    </Box>
  );
};

export default CountWithPercent;
